import React from "react";
import dynamic from "next/dynamic";
import { ServicesPartnerBlock } from "../index";
import Image from "next/image";

// Dynamic imports
const ServicesPartnerSlider = dynamic(() => import("./ServicesPartnerSlider"), {
  ssr: true,
});
import Section from "@/Components/LayoutComponents/Section";

interface ServicesPartnerProps {
  data: ServicesPartnerBlock;
  isMobile?: any;
}

const ServicesPartner: React.FC<ServicesPartnerProps> = ({ data, isMobile }) => {
  return (
    <Section className="bg-background-dark relative overflow-hidden">
      {/*Desktop & Tablet vector images*/}
      {!isMobile &&
        <>
          <Image
            src="/images/ServicesPage/Vector_blue.png"
            width={500}
            height={500}
            alt="banner-vector"
            className="absolute aspect-square w-[571px] top-0 left-0 bg-cover bg-no-repeat bg-center z-0"
            quality={80}
            loading="lazy"
            unoptimized
          />
          <Image
            src="/images/ServicesPage/Vector_green.png"
            width={865}
            height={865}
            alt="banner-vector"
            className="absolute aspect-square w-[865px] bottom-0 right-0 bg-cover bg-no-repeat bg-center z-0"
            quality={80}
            loading="lazy"
            unoptimized
          />
        </>
      }
      :
      {isMobile &&
        <>
          <Image
            src="/images/ServicesPage/mobile_vector_blue.png"
            width={1080}
            height={1080}
            alt="banner-vector-mobile"
            className="block md:hidden absolute top-[20%] left-1/2 -translate-x-1/2 w-full h-auto bg-cover bg-no-repeat bg-center z-0"
            quality={80}
            loading="lazy"
            unoptimized
          />
          <Image
            src="/images/ServicesPage/mobile_vector_green.png"
            width={1080}
            height={1080}
            alt="banner-vector-mobile"
            className="block md:hidden absolute top-[33%] left-1/2 -translate-x-1/2 w-full h-auto bg-cover bg-no-repeat bg-center z-0"
            quality={80}
            loading="lazy"
            unoptimized
          />
        </>
      }

      <div className="container text-center relative z-10">
        <h2 className="text-heading-1 font-bold text-primary-text-white xl:max-w-[904px] lg:max-w-[760px] mx-auto">
          {data?.title || ""}
        </h2>
        <p className="text-subtitle-2 font-regular text-secondary-text-white lg:max-w-[760px] mx-auto mt-3">
          {data?.sub_title || ""}
        </p>
      </div>
      <div className="xl:mt-10 mt-8 relative z-10">
        <ServicesPartnerSlider
          partnerCards={
            Array.isArray(data?.partnerCards) ? data.partnerCards : []
          }
        />
      </div>
    </Section>
  );
};
export default ServicesPartner;